import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import Login from './pages/login/index';
import Dashboard from './pages/dashboard/index';
import NewSpot from './pages/new-spot/index';
import GuardedRoute from './auth/guardedRoute';
import Terms from './pages/terms';
import Home from './pages/home';
import ChatPage from './pages/chat/index';


export default function Routes() {
    return (
        <Switch>
            <Route path="/" exact component={Home} />
            <Route path="/termos" exact component={Terms} />
            <Route path="/login" exact component={Login} />
            <GuardedRoute path="/dashboard" component={Dashboard} />
            <GuardedRoute path="/new" component={NewSpot}/>
            <GuardedRoute path="/chat" component={ChatPage}/>


            
        </Switch>
    )
}